import React, { useEffect, useState } from "react";
import { Form, Checkbox, Row, Col } from "antd";

interface Props {
  activeQuestion?: any;
  form?: any;
  subSelection?: any;
}

const LimitedMultipleOptions: React.FC<Props> = (props) => {
  const { subSelection } = props;
  const [checkedValues, setCheckedValues] = useState<any>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [isOtherChecked, setIsOtherChecked] = useState<boolean>(false);
  const [selectionOrder, setSelectionOrder] = useState<any>([]);

  const isProductQuestion =
    props?.activeQuestion?.question ===
    "Where do you like to shop your new skincare products?";

  useEffect(() => {
    setCheckedValues(subSelection ?? []);
    checkForOthers();
  }, [subSelection]);

  useEffect(() => {
    props.form.setFieldValue(
      "Where do you like to shop your new skincare products?",
      checkedValues
    );
  }, [checkedValues, inputValue]);

  const handleCheckboxChange = (values: any) => {
    let updatedValues = values;

    if (isOtherChecked) {
      updatedValues = [...values, inputValue];
    } else {
      setCheckedValues(values);
    }

    setCheckedValues(updatedValues);
    setSelectionOrder(
      updatedValues.map((val: string) => ({
        value: val,
        order:
          selectionOrder.find((item: any) => item.value === val)?.order ??
          selectionOrder.length + 1,
      }))
    );

    props.form.setFieldsValue({
      [props.activeQuestion.question]: updatedValues,
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const updatedCheckedValues = checkedValues.filter(
      (value: string) => value !== inputValue
    );
    setInputValue(newValue);
    setCheckedValues([...updatedCheckedValues, newValue]);
    setSelectionOrder([
      ...selectionOrder.filter((item: any) => item.value !== inputValue),
      { value: newValue, order: selectionOrder.length + 1 },
    ]);
  };

  const checkForOthers = () => {
    let otherVal = "";
    subSelection?.forEach((item: any) => {
      if (!props?.activeQuestion?.options?.includes(item)) {
        otherVal = item;
        setIsOtherChecked(true);
        setInputValue(item);
      }
    });
  };

  const handleOtherClick = () => {
    if (checkedValues.length >= 3 && !isOtherChecked) {
      return;
    }

    setIsOtherChecked((prev) => {
      if (prev) {
        setCheckedValues(
          checkedValues.filter((item: string) => item !== inputValue)
        );
        setInputValue("");
        setSelectionOrder(
          selectionOrder.filter((item: any) => item.value !== inputValue)
        );
      } else {
        setCheckedValues([...checkedValues, inputValue]);
        setSelectionOrder([
          ...selectionOrder,
          { value: inputValue, order: selectionOrder.length + 1 },
        ]);
      }
      return !prev;
    });
  };

  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-checkbox questionlist-checkbox--input"
        name={props?.activeQuestion?.question}
        rules={[
          { required: true, message: "You have to select at least one option" },
        ]}
      >
        <Checkbox.Group
          disabled={false}
          onChange={handleCheckboxChange}
          value={checkedValues}
          className={`${
            checkedValues?.length === 3 ? "all-checked" : ""
          } limited-multiple`}
        >
          <Row>
            {props?.activeQuestion?.options?.map((option: any, index: any) => (
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                xl={{ span: 8 }}
                key={index}
              >
                <Checkbox value={option} key={index}>
                  <span className="check-brand">
                    <span>{option}</span>
                    {checkedValues.includes(option) && (
                      <sup className="checked-number">
                        {
                          selectionOrder.find(
                            (item: any) => item.value === option
                          )?.order
                        }
                      </sup>
                    )}
                  </span>
                </Checkbox>
              </Col>
            ))}
            {isProductQuestion ? (
              <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }}>
                <div
                  className={`${
                    isOtherChecked ? "active-other" : ""
                  } other-section`}
                  onClick={handleOtherClick}
                >
                  <span>Other</span>
                </div>
              </Col>
            ) : null}
            {isOtherChecked && isProductQuestion ? (
              <Col xs={24} md={24} lg={24}>
                <input
                  type="text"
                  className="others-input"
                  value={inputValue}
                  onChange={handleInputChange}
                />
              </Col>
            ) : null}
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </div>
  );
};

export default LimitedMultipleOptions;
